export const LEFT = 'Left';
export const RIGHT = 'Right';
export const UP = 'Up';
export const DOWN = 'Down';

export const EVENT_SWIPED_UP = 'swipedup';
export const EVENT_SWIPED_DOWN = 'swipeddown';
export const EVENT_SWIPED_LEFT = 'swipedleft';
export const EVENT_SWIPED_RIGHT = 'swipedright';
export const EVENT_SWIPED_START = 'swipedstart';
export const EVENT_SWIPED = 'swiped';
export const EVENT_SWIPING = 'swiping';
export const EVENT_TAP = 'tap';
export const EVENT_TOUCHSTART_OR_MOUSEDOWN = 'touchstartormousedown';
export const EVENT_TOUCHEND_OR_MOUSEUP = 'touchendormouseup';
